import { GoABadge } from '@abgov/react-components';
import { Collision } from '../../models/collision';

export const getReportStatus = (
  reportStatusId: number,
  submission: Date,
): React.ReactNode => {
  switch (reportStatusId) {
    case 2:
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const timeDifference = Math.abs(today.getTime() - submission.getTime());
      const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

      if (daysDifference >= 30) {
        return <GoABadge type="important" content="30 days unassigned" />;
      } else {
        return <GoABadge type="information" content="Unassigned" />;
      }
    case 3:
      return <GoABadge type="information" content="Under review" />;
    case 4:
      return <GoABadge type="success" content="Approved" />;
    case 5:
      return <GoABadge type="emergency" content="Rejected" />;

    default:
      return '';
  }
};

export const getViolations = (collision: Collision): string[] => {
  const violations = [];

  if (collision.vehicles && collision.vehicles[0]) {
    const vehicle = collision.vehicles[0];

    if (vehicle.insuredBy) {
      const expiredDate = new Date(
        vehicle.insuredBy.insurancePolicyExpirationDate,
      );
      const collisionDate = new Date(collision.dateOfCollision!);

      if (collisionDate.getTime() > expiredDate.getTime()) {
        violations.push('Expired Insurance');
      }
    }

    if (vehicle.driver) {
      if (vehicle.driver.isLicenceExpired) {
        violations.push("Expired Driver's Licence");
      }

      if (vehicle.driver.isLicenceSuspended) {
        violations.push("Suspended Driver's Licence");
      }
    }

    if (vehicle.isPlateExpired) {
      violations.push('Expired Vehicle Plate');
    }

    if (vehicle.isPlateLostOrStolen) {
      violations.push('Lost or Stolen Plate');
    }
  }

  return violations;
};
